module.exports = __webpack_public_path__ + "img/petstairs27.eb4d9fae.jpg";